import React from 'react';
import { useSelector } from 'react-redux';
import styled from "styled-components";
import { Table } from "react-bootstrap"

const Card = styled.div`
box-shadow: 0px 1px 4px #c5c5c5;
-webkit-box-shadow: 0px 1px 4px #c5c5c5;
-moz-box-shadow: 0px 1px 4px #c5c5c5;
margin-bottom: 1em;
border-radius: 4px;
background: white;
`
const CardHeader = styled.div`
padding: 20px 16px;
font-size: 1.2em;
background-color: #f1f1f1;
color: #303030;
display: flex;
justify-content: space-between;
`

function TenantUsersList() {

const tenantActiveUsers = useSelector(store => store.app.tenantActiveUsers)

  return (
    <Card>
        {/* <CardHeader>Active users list ({tenantActiveUsers && tenantActiveUsers.users.length})</CardHeader> */}
        <Table striped bordered hover style={{width: "100%"}}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Role</th>
                </tr>
            </thead>
            {/* <tbody>
                {tenantActiveUsers && tenantActiveUsers.users.map(user => {

                    return (
                        <tr key={user.id}>
                            <td>{user.id}</td>
                            <td>{user.FirstName}</td>
                            <td>{user.LastName}</td>
                            <td>{user.Email}</td>
                            <td>{user.SystemAdmin === "true" ? "Admin" : "User"}</td>
                        </tr>
                    )
                })}
            </tbody> */}
        </Table>
    </Card>
  )
}

export default TenantUsersList